
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ProductPrice extends Vue {
  @Prop({ type: String, required: true })
  price!: string;

  get priceFormatted(): string {
    const priceNumber = parseFloat(this.price);
    return isNaN(priceNumber) ? this.price : priceNumber.toFixed(2);
  }
}
